define('vspot-angular/services/reports-service',[], function () {
    'use strict';

    return ['$http', '$timeout', 'localize', 'resources.OrgReports', function ($http, $timeout, localize, OrgReports) {

        return {
            query: function() {
                return OrgReports.query();
            },
            get: function(id) {
                return OrgReports.get({ id: id });
            },
            save: function(postData) {
                return OrgReports.save(postData);
            },
            update: function(postData) {
                return OrgReports.update(postData);
            },
            delete: function(id) {
                return OrgReports.delete({ id: id });
            },
            runReport: function(id) {
                return OrgReports.runReport({ report_id: id });
            },

            /*
             *  Creates HTML in a new window for a list of tasks and assignments for a given day
             */
            printDay: function(activityId, eventId) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printday?selected_activity=' + activityId + '&event_id=' + eventId);
                });
            },

            /*
             *  Creates HTML in a new window for a printable list participants in an activity
             *  
             *  @param activityId: Number id of the activity we're reporting on
             *  @param includeHours: Boolean indicating whether participant hour totals should be included, true only available to premium users
             *  @param includeExtraFields: Boolean indicating whether extra field data should be included in the report
             */
            printRoster: function(activityId, includeHours, includeExtraFields) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printroster?' +
                        'selected_activity=' + activityId +
                        '&include_hours=' + includeHours +
                        '&include_extra_fields=' + includeExtraFields);
                });
            },

            /*
             *  Creates HTML in a new window for a printable signup sheet
             *  
             *  @param activityId: Number id of the activity we're reporting on
             *  @param hideContactInfo: Boolean indicating whether participant information (name, email, phone, extra field answers if extra fields are displayed) is included on the report
             *  @param includeExtraFields: Boolean indicating whether extra field data should be included in the report
             *  @param startDate: the first date to display information for
             *  @param endDate: the last date to display information for (inclusive) 
             */
            printSignup: function(activityId, hideContactInfo, includeExtraFields, hideEmptySpots, startDate, endDate, sort_by) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printsignup?' +
                        'selected_activity=' + activityId +
                        '&hide_contact_info=' + hideContactInfo +
                        '&include_extra_fields=' + includeExtraFields +
                        '&hide_empty_spots=' + hideEmptySpots +
                        '&start_date=' + startDate +
                        '&end_date=' + endDate +
                        '&sort_by=' + sort_by
                    );
                });
            },

            /**
             * Opens interactive report  in current window
             *
             * @param activityId: Number id of the activity we're reporting on
             * @param startDate: The first date to display information for
             * @param endDate: The last date to display information for (inclusive)
             */
            openInteractive: function(activityId, startDate, endDate) {
                $timeout(function () {

                    window.location = '/reports/?' +
                        'report=whoscoming' +
                        '&activity_id=' + activityId +
                        '&start_date=' + startDate +
                        '&end_date=' + endDate;

                });

            },


            /*
             *  Creates HTML in a new window for a printable list participants in an activity
             *
             *  @param activityId: Number id of the activity we're reporting on
             *  @param includeComments: Boolean indicating whether comments should be included
             *  @param startDate: the first date to display information for
             *  @param endDate: the last date to display information for (inclusive)
             */
            printSummary: function(activityId, includeComments, startDate, endDate) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printsummary?' +
                        'selected_activity=' + activityId +
                        '&include_comments=' + includeComments +
                        '&start_date=' + startDate +
                        '&end_date=' + endDate);
                });

            },

            /*
             *  Exports a csv file format of the activity information
             */
            exportCsv: function(activityId) {
                window.location = '/api/reports/exportcsv?selected_activity=' + activityId;
            },

            /*
             *  Shows a print view of an activity's waiver in a new window
             */
            printWaiver: function(activityId) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printwaiver?selected_activity=' + activityId);
                });
            },

            /*
             *  Shows a print view of an activity's contributions in a new window
             */
            printContributions: function(activityId) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printcontributions?selected_activity=' + activityId);
                });
            },

            /*
             *  Shows a print view of an activity's waitlist participants in a new window
             */
            printWaitlisters: function(activityId) {
                $timeout(function() {
                    Vspot.global_helper.open_new_window('/api/reports/printwaitlisters?selected_activity=' + activityId);
                });
            }

        };
    }];
});

